import React from 'react';
import '../css/Contact.css';
import emailjs from 'emailjs-com';
import Footer from './Footer';
import Navbar from './Navbar';


function Contact() {

    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('service_3g8o7rt', 'template_cisid1e', e.target,
        'user_19S92BkXlRsqndYW2khjQ')
            .then((result) => {
                
                alert('We will contact you soon!');
                console.log(result.text);
            }, (error) => {
                alert('Something went wrong!');
                console.log(error.text);
            });
        e.target.reset();
       
    }
    return (
        <div className="contact" id="contact">

            <div className="contact__form">
                <div className="center">
                    <h1 className="animate__animated animate__bounce animate__infinite">Get In Touch</h1>
                    <hr />
                    <p  className="animate__animated animate__heartBeat animate__duration5s">Have a sweet project in mind or just want to say hi?
                Feel free to send me a message!</p>
                </div>

                <form onSubmit={sendEmail}>
                    <input required={true} type="text" placeholder="NAME" name='name' /><br />
                    <input required={true} type="email" placeholder="EMAIL" name='email' /><br />
                    <input required={true} type="text" placeholder="SUBJECT" name='subject' /><br />
                    <input required={true} type="text" placeholder="MESSAGE" name='message' /><br />
                    <button type="submit">SEND ME</button>
                </form>
            </div>
            <Footer />
        </div>
    )
}

export default Contact;


